<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item
          label="到账账户"
          prop="payment_name"
          :rules="[
            {
              required: true,
              message: '请选择到账账户',
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="state.model.bank_account_id">
            <el-option
              v-for="item in state.bankAccountData"
              :key="item"
              :label="item.name + '(' + item.account + ')'"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadBankAccount()">
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="付款银行账户"
          prop="payment_name"
          :rules="[
            {
              required: true,
              message: '请填写付款银行账户',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.payment_name"></el-input>
        </el-form-item>
        <el-form-item
          label="付款银行账号"
          prop="payment_account"
          :rules="[
            {
              required: true,
              message: '请填写付款银行账号',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="state.model.payment_account"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="付款开户银行"
          prop="payment_opening_bank"
          :rules="[
            {
              required: true,
              message: '请填写付款开户银行',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.payment_opening_bank"></el-input>
        </el-form-item>
        <el-form-item
          label="到账时间"
          prop="received_date"
          :rules="[
            {
              required: true,
              message: '请选择到账时间',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="state.model.received_date"
            type="date"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item
          label="到账金额"
          prop="received_amount"
          :rules="[
            {
              required: true,
              message: '请填写到账金额',
              trigger: 'blur',
            },
          ]"
        >
          <el-input-number
            v-model="state.model.received_amount"
            :controls="false"
            class="number-input-left number-input-suffix"
            :precision="2"
            suffix="元"
            @change="onMoneyChange()"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="手续费"
          prop="service_fee"
          :rules="[
            {
              required: true,
              message: '请填写手续费',
              trigger: 'blur',
            },
          ]"
        >
          <el-input-number
            v-model="state.model.service_fee"
            :controls="false"
            class="number-input-left number-input-suffix"
            :precision="2"
            suffix="元"
            @change="onMoneyChange()"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="实际到账金额"
          prop="service_fee"
          :rules="[
            {
              required: true,
              message: '请填写手续费',
              trigger: 'blur',
            },
          ]"
          class=""
        >
          <el-input-number
            v-model="state.model.real_received_amount"
            :controls="false"
            class="number-input-left number-input-suffix"
            :precision="2"
            suffix="元"
            readonly
          ></el-input-number>
        </el-form-item>
        <el-form-item label="摘要信息">
          <el-input v-model="state.model.summary" type="textarea" />
        </el-form-item>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  bankreceived_add,
  bankreceived_detail,
  bankreceived_edit,
} from "@/http/bankreceived";
import { data_bankaccount_select } from "@/http/data";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        fieldsArr: [],
      },
    });
    onMounted(() => {
      onLoadBankAccount();

      if (props.id) {
        bankreceived_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            state.model.fieldsArr = JSON.parse(state.model.fields);
          }
        });
      }
    });

    const onLoadBankAccount = () => {
      data_bankaccount_select().then((res) => {
        if (res.status == 200) state.bankAccountData = res.data.data?.list;
      });
    };

    const onMoneyChange = () => {
      state.model.real_received_amount =
        state.model.received_amount - state.model.service_fee;
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          state.model.fields = JSON.stringify(state.model.fieldsArr);

          if (props.id) {
            bankreceived_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            state.model.customer_id = props.customer_id;
            bankreceived_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadBankAccount,
      onSubmit,
      onMoneyChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
